<script lang="ts">
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export type svgIconSize =
  | iconSize
  | "height-xxs"
  | "height-xs"
  | "height-sm"
  | "height-md"
  | "height-lg"
  | "height-xl"
  | "height-xxl"
  | "width-xxs"
  | "width-xs"
  | "width-sm"
  | "width-md"
  | "width-lg"
  | "width-xl"
  | "width-xxl";
</script>

<script setup lang="ts">
import { computed } from "vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";

export interface SVGWrapperIconProps {
  viewBox: string;
  className?: string;
  size: svgIconSize;

  background?: colorTag;
}

const props = withDefaults(defineProps<SVGWrapperIconProps>(), {
  className: "",
  background: "transparent",
  size: "md",
});

const backgroundClass = computed((): string => `bg-${props.background}`);
const sizeClass = computed((): string => `icon-${props.size}`);
</script>

<template>
  <svg
    :class="{
      [className]: className.length > 0,
      [backgroundClass]: background !== undefined,
      [sizeClass]: true,
    }"
    :viewBox="viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <slot />
  </svg>
</template>
